import { createFileRoute, redirect } from '@tanstack/react-router';

import { OneRosterAuth } from '@/components/auth/auth.context';
import { MapTestRoot } from '@/features/placements-v2/components/MapTestRoot';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import {
  AppPageHeader,
  BreadcrumbItemProps,
} from '@/features/shared/components/AppPageHeader';
import { getImpersonationStatus } from '@/hooks/useImpersonation';
import { useOneRosterAuth } from '@/hooks/useOneRosterAuth';
import { UserRoles } from '@/lib/constants/auth.constants.ts';

export const Route = createFileRoute('/_app/app/map-test')({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const allowedRoles = [
      UserRoles.SYSTEM_ADMINISTRATOR,
      UserRoles.ADMINISTRATOR,
      UserRoles.STUDENT,
    ];

    const auth = context.auth as OneRosterAuth;
    const { isImpersonated } = await getImpersonationStatus();

    const roles = auth?.user?.roles.map((role) => role.role) ?? [];
    const isAide = roles.includes(UserRoles.AIDE);

    if (isAide && isImpersonated) {
      allowedRoles.push(UserRoles.AIDE);
    }

    if (!roles.some((role) => allowedRoles.includes(role as UserRoles))) {
      throw redirect({ to: '/app/my-learning-report', replace: true });
    }
  },
  ssr: false,
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'App',
    link: { to: '/app' },
  },
  {
    label: 'My MAP Test',
    link: { to: '/app/map-test' },
  },
];

function RouteComponent() {
  const { user } = useOneRosterAuth();

  if (!user) {
    return null;
  }

  return (
    <AppPageContent>
      <AppPageHeader title="My MAP Test" breadcrumbItems={breadcrumbItems} />
      <MapTestRoot user={user} />
    </AppPageContent>
  );
}
